<template>
  <SidebarCard productName="Property Details" :header="$t('tbs_home_property')">
    <div class="tw:mb-3 tw:flex tw:flex-row tw:gap-x-2.5 tw:items-center">
      <div>
        <img
          :src="`https://imgcy.trivago.com/c_fill,d_dummy.jpeg,e_sharpen:60,f_auto,h_32,q_auto,w_32/${currentAccommodation?.mainImageUrls?.imagePath || 'dummy.jpeg'}`"
          :alt="`Property image for ${currentAccommodation?.name || 'accommodation'}`"
          class="tw:rounded-lg"
        />
      </div>
      <div>
        <h3 class="tw:font-bold tw:text-sm">{{ currentAccommodation?.name }}</h3>
        <p class="tw:text-xxs tw:text-gray-600">{{ `ID: ${currentAccommodation?.accommodationId}` }}</p>
      </div>
    </div>
    <BaseLink to="/property-details/basic-information" @click="triggerEvent" class="tw:font-bold tw:text-blue-700">{{
      $t('property_details_cta')
    }}</BaseLink>
  </SidebarCard>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import BaseLink from '@/components/BaseLink.vue'
import SidebarCard from '@/components/homePage/sidebar/SidebarCard.vue'
import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId, useAccommodationsByOrgId } from '@/layouts/queries'

const store = useStore()
const selectedOrganisationId = computed(() => store.state.session.selectedOrganisation?.id)
const { currentAccommodation } = useAccommodationsByOrgId(selectedOrganisationId)

const triggerEvent = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_SIDEBAR_PROPERTY_DETAILS_CLICKED, {
    itemId: selectedAccommodationId.value,
  })
}
</script>
